import React from 'react';
import Logo from '../../Logo/Logo';
import HeaderDivider from '../HeaderDivider';
import TitleBlock from './TitleBlock';
import HeaderTools from './HeaderTools';
import styles from './LeftHeader.module.css';

/** Left half of the bar: logo, title over the save status, then the map tools. */
const LeftHeader = () => (
    <div className={styles.left}>
        <Logo className={styles.logo} />
        <TitleBlock />
        <HeaderDivider className={styles.desktopOnly} />
        <HeaderTools />
    </div>
);

export default LeftHeader;
